import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from "@angular/core";
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from "@angular/forms";

@Component({
    selector: 'camera-capture',
    templateUrl: './camera-capture.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: CameraCaptureComponent,
            multi: true
        }
    ]
})
export class CameraCaptureComponent implements ControlValueAccessor, Validator {
    @Output() onChange = new EventEmitter<File | null>();
    onChangeReactive: Function = () => { };
    onTouchedReactive: Function = () => { };

    public file: File | null = null;

    @HostListener('change', ['$event.target.files'])
    emitFiles(event: FileList) {
        this.onTouchedReactive();

        const file = this.file = event && event.item(0);

        const formData = new FormData();
        formData.append('file', file!);

        this.onChangeReactive(file);
        this.onChange.emit(file);
    }

    constructor(private host: ElementRef<HTMLInputElement>) {

    }

    writeValue(value: null) {
        // clear file input
        this.host.nativeElement.value = '';
        this.file = null;
    }

    registerOnChange(fn: Function) { this.onChangeReactive = fn; }
    registerOnTouched(fn: Function) { this.onTouchedReactive = fn; }

    validate(control: AbstractControl) {
        if (!this.file) return { required: true };

        return null;
    }
}